/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PwC Web App Accelerator API
 * OpenAPI spec version: 1.0
 */

export type CleansingStatus =
    (typeof CleansingStatus)[keyof typeof CleansingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CleansingStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
} as const;
